import axios from "axios"
import router from "@/router"
import { commit } from "lodash/seq"
import api from "@/store/api";

export const state = {
  data: {
    links: []
  }
}

export const mutations = {
  ADD_LINK (state, link) {
    state.data.links.unshift(link)
  },
  SET_LINKS (state, { data }) {
    state.data.links = data
  },
  DELETE_LINK (state, { id }) {
    state.data.links = state.data.links.filter(link => link._id !== id && link.id !== id)
  },
  UPDATE_LINK (state, updatedLink) {
    const idx = state.data.links.findIndex(l => l._id === updatedLink._id)
    if (idx !== -1) {
      state.data.links.splice(idx, 1, updatedLink)
    }
  }
}

export const actions = {

  async getLinks ({ commit }) {
    try {
      const { data } = await axios.get(`${api.links}`)
      commit('SET_LINKS', { data })
    } catch (e) {
      console.log(e)
    }
  },
  async addLink ({ commit } , { title, url, id, gradient }) {
    try {
      const { data } = await axios.post(`${api.links}`, { title, url, gradient })
      commit('ADD_LINK', data)
    } catch (e) {
      console.log(e)
    }
  },

  async deleteLink ({ commit }, { id }) {
    try {
      await axios.delete(`${api.links}/${id}`)
      commit('DELETE_LINK', { id })
    } catch (e) {
      console.log(e)
    }
  },

  async updateLink ({ commit }, link) {
    try {
      const { data } = await axios.put(`${api.links}/${link._id}`, link)
      commit('UPDATE_LINK', data)
    } catch (e) {
      console.log(e)
    }
  },
}